import {CourseTrack, School} from "../../../../domain/entities/entities";
import {InterfaceSchoolUseCases} from "../../../../domain/usecase/impl/schoolUseCases";
import {InterfaceCourseTrackUseCases} from "../../../../domain/usecase/impl/courseTrackUseCases";
import {ActionContext} from "vuex";

class CategoriesState {
  schools: School[] = Array<School>();
  school: School = new School();
  courseTracks: CourseTrack[] = Array<CourseTrack>();
}

const state = new CategoriesState();

const mutations = {
  LIST_SCHOOLS(state: CategoriesState, schools: School[]): void {
    state.schools = schools;
  },

  GET_SCHOOL(state: CategoriesState, school: School): void {
    state.school = school;
  },

  LIST_COURSE_TRACKS(
    state: CategoriesState,
    courseTracks: CourseTrack[]
  ): void {
    state.courseTracks = courseTracks;
  }
};

const actions = {
  async loadSchools({ commit }): Promise<void> {
    const schools = await InterfaceSchoolUseCases.list();
    commit("LIST_SCHOOLS", schools);
  },
  async loadSchool({ commit }: any, school_id: number): Promise<void> {
    const school = await InterfaceSchoolUseCases.get(school_id);
    commit("GET_SCHOOL", school);
  },

  async loadCourseTracks({ commit }: any): Promise<CourseTrack[]> {
    const courseTracks = await InterfaceCourseTrackUseCases.list();
    commit("LIST_COURSE_TRACKS", courseTracks);
    return courseTracks;
  },

  async loadCourseTrack({ commit }, id: number): Promise<CourseTrack> {
    const courseTrack = await InterfaceCourseTrackUseCases.get(id);
    commit("GET_COURSE_TRACK", courseTrack);
    return courseTrack;
  },

  async loadCourseTracksOfSchool(
    { commit }: ActionContext<CategoriesState, CategoriesState>,
    school_id: number
  ): Promise<CourseTrack[]> {
    const courseTracks = await InterfaceCourseTrackUseCases.listBySchool(school_id);
    commit("LIST_COURSE_TRACKS", courseTracks);
    return courseTracks;
  }
};

const getters = {
  schools: (state: CategoriesState) => state.schools,
  courseTracks: (state: CategoriesState) => state.courseTracks
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
